export const REQUEST_CANCELED_STATUS_ID = 7
export const REQUEST_FINISHED_STATUS_ID = 6
export const REQUEST_DRAFT_STATUS_ID = 1
export const REQUEST_AWAITING_SAMPLE_STATUS_ID = 2
export const EXAM_CANCELED_STATUS_ID = 9
export const EXAM_FINISHED_STATUS_ID = 8
export const EXAM_SENT_STATUS_ID = 8
